import { get } from "react-hook-form";
import { getFormsForUser } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/formsContext";
import { useToken } from "@dexteel/mesf-core";

export const useGetFormAssetForFilter = () => {
	const {
		actions: { setFormForUser },
	} = useFormsContext();

	const { getUserId } = useToken();

	return async () => {
		return getFormsForUser(getUserId()).then((res) => {
			if (res.ok) {
				const formsForUserRows = get(res, "data", null);
				const instanceTable = formsForUserRows.tables[0];
				setFormForUser(instanceTable.rows);
			}
			return res;
		});
	};
};
